// Copyright 2026 Zibby Lab. Apache-2.0.
//
// DangerButton — atomic outlined-red action button.
//
// Used for any destructive / state-changing-and-hard-to-undo action:
//   - "Delete pipeline" (workflow danger zone)
//   - "Disable warm workflow"
//   - "Destroy app instance" (future)
//   - "Revoke credential" (future)
//
// Variant of the red-outline button used across the app for actions
// the user should pause-and-think before clicking. Outlined (not
// solid-filled) so it doesn't compete with primary CTAs visually.
//
// Usage:
//   <DangerButton icon={trashOutline} onClick={handleDelete}>
//     Delete pipeline
//   </DangerButton>

import React from 'react';
import PropTypes from 'prop-types';
import { IonIcon } from '@ionic/react';
import './DangerButton.css';

const DangerButton = ({
  children,
  icon,
  onClick,
  disabled = false,
  type = 'button',
  className = '',
  ariaLabel,
  title,
}) => (
  <button
    type={type}
    className={`danger-btn ${className}`.trim()}
    onClick={onClick}
    disabled={disabled}
    aria-label={ariaLabel}
    title={title}
  >
    {icon && <IonIcon icon={icon} aria-hidden="true" />}
    {children}
  </button>
);

DangerButton.propTypes = {
  children: PropTypes.node.isRequired,
  icon: PropTypes.any,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  className: PropTypes.string,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
};

export default DangerButton;
